import Picker from 'pickerjs'
import AbstractField from "championship/src/classes/form/fields/abstract";
import NodeHelper from '../../../helpers/node_helper';
import {RangedDigitalMaskedInput} from 'championship/src/classes/utils/ranged_masked_input'
import 'pickerjs/dist/picker.min.css'
import './style.css'

class TimeField extends AbstractField {
    __init_dom_schema(){
        return {
            picker_popup: '.picker-popup',
            picker_wrapper: '.picker-wrapper',
            time_input: 'input[type="time"]',
            text_input: {
                selector: 'input[type="text"]',
                actions: {
                    'ranged_mask.changed': this.onRangedMaskPicked.bind(this)
                }
            },
            hidden_input: {
                selector: 'input[type="hidden"]',
                actions: {
                    'change': this.onPickerPicked.bind(this)
                }
            },
            wrapper: {
                selector: '.js-form-field__wrapper',
                actions: {
                    'click': this.onTogglePopup.bind(this),
                }
            },
            save_button: {
                selector: '.button.-save',
                actions: {
                    'click': this.onButtonSaveClicked.bind(this)
                }
            }
        }
    }

    __init(node){

        this.registerEvents('changed')

        // this.masked = new RangedDigitalMaskedInput(this.dom.hidden_input, {
        this.masked = new RangedDigitalMaskedInput(this.dom.text_input, {
            // mask: 'first<<0-23>>second:<<0-59>>third',
            // mask: 'first<<4-23>>second:<<1-59>>third',
            // mask: '<<0-23>>::second<<0-59>>',
            // mask: '<<0-23>> : <<0-59>>',
            mask: '<<0-23>>:<<0-59>>',
            pad: true,
        })

        this.dom.text_input.value = this.dom.time_input.value
        // console.log(this.dom.text_input.value, this.dom.time_input.value)

        this.picker = new Picker(this.dom.hidden_input, {
            // format: 'HH : mm',
            format: 'HH:mm',
            controls: true,
            inline: true,
            headers: true,
            container: this.dom.picker_wrapper,
            text: {
                title: 'Выберите время',
                cancel: 'Отменить',
                confirm: 'Применить',
                year: 'Год',
                month: 'Месяц',
                day: 'День',
                hour: 'Часы',
                minute: 'Минуты',
                second: 'Секунды',
                millisecond: 'Миллисекунда',
            },
        })

        // this.dom.picker_wrapper.onchange = (...args) => {console.log(args)}
    }
    onRangedMaskPicked(event){
        // this._apply(this.dom.hidden_input.value)
        // this.dom.text_input.value = value
        this.dom.time_input.value = this.dom.text_input.value.replace(' ','')

        this.dispatchEvent('changed')
    }
    onPickerPicked(event){
        // this._apply(this.dom.hidden_input.value)
        this.dom.text_input.value = this.dom.hidden_input.value
        this.dom.time_input.value = this.dom.hidden_input.value

        this.dispatchEvent('changed')
    }

    // _apply(value){
    //     this.dom.text_input.value = value
    //     this.dom.hidden_input.value = value
    //     this.dom.time_input.value = value
    // }

    onTogglePopup(event){
        this.togglePopup()
    }

    onButtonSaveClicked(event){
        this.picker.pick()
        this.togglePopup()
    }

    togglePopup(bool = null){
        bool = NodeHelper.ToggleClass(this.dom.picker_popup, 'is--active', bool)
        if (bool) {
          this.focus()
        }
    }

    isRequired() {
        return this.dom.time_input.hasAttribute('required')
    }

    isFilled() {
      return this.dom.time_input.value !== ''
    }

    getValue(){
        return this.dom.time_input.value
    }

    setValue(value){
        this.dom.time_input.value = value
        this.dom.text_input.value = value
    }

    unfocus() {
        this.togglePopup(false)
    }
}

export default TimeField